import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ContentService {
  constructor(private http: HttpClient) {}

  // Fetch a list of scheduled posts (content)
  getScheduledPosts(): Observable<any> {
    return this.http.get('/api/content/scheduled');  // Replace with actual endpoint
  }

  // Create or update content
  createOrUpdateContent(content: any): Observable<any> {
    return this.http.post('/api/content', content);  // Replace with actual endpoint
  }

  // Get post analytics (server hit)
  getPostAnalytics(contentId: string): Observable<any> {
    return this.http.get(`/api/server-hit/${contentId}`);
  }

  // Method to post content based on platform (ContactMechTypeId)
  postContentToSocialMedia(content: any, platformId: string, contentTypeId: string, workEffortTypeId: string): Observable<any> {
    // Get platform-specific API endpoint and format content accordingly
    let apiEndpoint: string;
    let apiPayload: any;

    switch(platformId) {
      case 'facebook':
        apiEndpoint = '/api/facebook/post';
        apiPayload = this.formatFacebookPost(content, contentTypeId, workEffortTypeId);
        break;
      case 'twitter':
        apiEndpoint = '/api/twitter/post';
        apiPayload = this.formatTwitterPost(content, contentTypeId, workEffortTypeId);
        break;
      case 'instagram':
        apiEndpoint = '/api/instagram/post';
        apiPayload = this.formatInstagramPost(content, contentTypeId, workEffortTypeId);
        break;
      case 'google':
        apiEndpoint = '/api/google/post';
        apiPayload = this.formatGooglePost(content, contentTypeId, workEffortTypeId);
        break;
      default:
        //return console.log(throwError('Unsupported platform'));
    }

    return this.http.post(apiEndpoint, apiPayload);
  }

  // Helper method to format the content for Facebook
  private formatFacebookPost(content: any, contentTypeId: string, workEffortTypeId: string): any {
    let formattedContent = { text: content.text, imageUrl: content.imageUrl,videoUrl:content.videoUrl,scheduleTime:content.scheduleTime };
    if (contentTypeId === 'image') {
      formattedContent.imageUrl = content.imageUrl;
    } else if (contentTypeId === 'video') {
      formattedContent.videoUrl = content.videoUrl;
    }
    // Add scheduling logic based on WorkEffortTypeId
    if (workEffortTypeId === 'scheduled') {
      formattedContent.scheduleTime = content.scheduledDate;
    }
    return formattedContent;
  }

  // Similar methods for Twitter, Instagram, and Google can be implemented here
  private formatTwitterPost(content: any, contentTypeId: string, workEffortTypeId: string): any {
    // Format content for Twitter post
  }

  private formatInstagramPost(content: any, contentTypeId: string, workEffortTypeId: string): any {
    // Format content for Instagram post
  }

  private formatGooglePost(content: any, contentTypeId: string, workEffortTypeId: string): any {
    // Format content for Google post
  }
}

